import styled from 'styled-components'

import { HeightClass } from '~/utils/enum/classes'

import { MultiselectionProps } from '../type'

const borderColor = {
  success: '#74EC81',
  error: '#FF7373',
  default: '#006bff'
}

export const MultiselectionButton = styled.input<{
  disabled: boolean
  status?: MultiselectionProps['status']
  heightClass?: HeightClass
}>`
  &[type='checkbox'] {
    padding: ${({ theme, heightClass = 'regular' }) =>
      theme.explicitSelectionButton[heightClass]?.innerCirclePadding || 0}px;
  }

  display: inline-block;
  margin: 0;
  border-radius: 50%;

  width: ${({ theme, heightClass = 'regular' }) =>
    theme.explicitSelectionButton[heightClass]?.width || 0}px;

  height: ${({ theme, heightClass = 'regular' }) =>
    theme.explicitSelectionButton[heightClass]?.height || 0}px;

  outline: none;

  border: ${({ theme, heightClass = 'regular', status = 'default' }) => `
      ${theme.explicitSelectionButton[heightClass]?.borderSize || 0}px
    solid ${borderColor[status]}`};

  ${({ disabled }) => disabled && 'border-style: dashed;'}

  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  position: relative;

  &:before {
    content: '';
    position: absolute;
    border-radius: 100%;

    border: ${({ theme, heightClass = 'regular' }) =>
        theme.explicitSelectionButton[heightClass]?.borderSize || 0}px
      solid #006bff;

    width: ${({ theme, heightClass = 'regular' }) =>
      (theme.explicitSelectionButton[heightClass]?.width || 0) -
      (theme.explicitSelectionButton[heightClass]?.innerCirclePadding || 0) *
        2 -
      (theme.explicitSelectionButton[heightClass]?.borderSize || 0) * 2}px;

    height: ${({ theme, heightClass = 'regular' }) =>
      (theme.explicitSelectionButton[heightClass]?.height || 0) -
      (theme.explicitSelectionButton[heightClass]?.innerCirclePadding || 0) *
        2 -
      (theme.explicitSelectionButton[heightClass]?.borderSize || 0) * 2}px;

    transition: background 0.15s;

    ${({ disabled }) => disabled && 'cursor: not-allowed'};
  }

  &:checked {
    &:before {
      background-color: #006bff;
    }
  }
`
